import { ContentFilters, ContentTopBar } from 'components';
import { AddNotificationModal } from 'features/notification/components/modal/AddnotificationModal';
import { NotificationsListsFilterForm } from 'features/notification/components/notification-main-filter/notifications-listfilter-form';
import { NotificationListsFilterFormValues } from 'features/notification/components/type';
import { useState } from 'react';
import { CompanyType } from 'types';
// ../notification-main-filter/notifications-listfilter-form
type VendingTopBarProps = {
  getInitialFilterValues: NotificationListsFilterFormValues;
  handleFilter: (values: NotificationListsFilterFormValues) => void;
  refetch: any,
};
export const NotificationTopBarLists = ({
  getInitialFilterValues,
  handleFilter,
  refetch,

}: VendingTopBarProps) => {
  useState<CompanyType>();
  const formId = 'notification-lists-filters-form';
  const [showAddItemModal, setShowAddItemModal] = useState<boolean>(false);
  // const handleOpenModal = () => {
  //   setShowAddItemModal(true)
  //   document.body.style.overflow = 'hidden';
  // }

  const handleCloseModal = () => {
    setShowAddItemModal(false)
    document.body.style.overflow = 'visible';
  }

  return (
    <>
      <div className={`cstmrightmdl ${showAddItemModal && "show"}`}>
        <AddNotificationModal onClose={handleCloseModal} refetch={refetch} showAddItemModal={showAddItemModal} />
      </div>

       {/* <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <ArrowLeftOutlined
            style={{ fontSize: 20, cursor: "pointer" }}
            onClick={() => navigate("/notification/lists")}
          />
          <span>Notification List - Details</span>
        </div> */}
        
      <ContentTopBar
        title={'Notification List'}
        
      /> 

      <ContentFilters formId={formId}>
        <NotificationsListsFilterForm
          formId={formId}
          handleFilter={handleFilter}
          initialValues={getInitialFilterValues}
        />
      </ContentFilters>
    </>
  );
};
